import { render, staticRenderFns } from "./ShapeLinksEdit.vue?vue&type=template&id=3f1cc573&"
import script from "./ShapeLinksEdit.vue?vue&type=script&lang=js&"
export * from "./ShapeLinksEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports